import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/axc/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetAlumnoCarreraListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listAlumnoCarrera(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupAlumnoCarrera(query = { page: 1, pageSize: 5 }) {
  return listAlumnoCarrera(query);
}

export function getAlumnoCarrera(id) {
  return requestAndUnwrap(apiClient.get(`/api/axc/${id}`));
}

export function deleteAlumnoCarrera(id) {
  return requestAndUnwrap(apiClient.get(`/api/axc/delete/${id}`));
}

export function saveAlumnoCarrera(payload) {
  return requestAndUnwrap(apiClient.post('/api/axc', payload));
}

export function updateAlumnoCarrera(payload) {
  return requestAndUnwrap(apiClient.post('/api/axc/update', payload));
}

export function inscribirAlumno(payload) {
  return requestAndUnwrap(apiClient.post('/api/axc/inscribir', payload));
}
